export default __webpack_public_path__ + "static/media/boiler.d029a340.png";